/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */
//Show and Hide Product Badge Popup
document.addEventListener("DOMContentLoaded", (event) => {
    const widthMatch = window.matchMedia("(max-width: 740px)");
    const productBadge = document.querySelector(".product_image_icon");
    const productBadgeContainer = document.querySelector(".recommended_by_image_icon_container");
    const producBadgePop = document.querySelector(".recommended-by-popup-container");
    const productThumbnails = document.querySelector(".product__thumbnail-list-inner");
    const productMainImage = document.querySelector(".product__media-list");
    const producBadgePopClose = document.querySelector(".recommended-by-popup-close");
    function showPopup() {
        if (productThumbnails) {
            productThumbnails.style.opacity = "0.5";
        }
        productMainImage.style.opacity = "0.5";
        producBadgePop.style.display = "block";
    }
    function hidePopup() {
        if (productThumbnails) {
            productThumbnails.style.opacity = "1";
        }
        productMainImage.style.opacity = "1";
        producBadgePop.style.display = "none";
    }
    if (widthMatch.matches && productBadge) { // If media query matches
        //Small device
        productBadge.addEventListener("click", showPopup);
        producBadgePopClose.addEventListener("click", hidePopup);
        productBadgeContainer.addEventListener('keydown', (keyEvent) => {
            if (keyEvent.keyCode === 13 || keyEvent.keyCode === 32) {
                showPopup()
            }
        });
        producBadgePopClose.addEventListener('keydown', (keyEvent) => {
            if (keyEvent.keyCode === 13 || keyEvent.keyCode === 32) {
                hidePopup()
            }
        });
    } else if(productBadge){
        //Large device
        productBadge.addEventListener("mouseover", showPopup);
        productBadge.addEventListener("mouseleave", hidePopup);
        productBadgeContainer.addEventListener("focus", showPopup);
        productBadgeContainer.addEventListener("blur", hidePopup);
    }
      
    widthMatch.addEventListener('change', function(widthEvent) {
    if (widthEvent.matches && productBadge) {
        console.log("small")
        productBadge.removeEventListener("mouseover", showPopup);
        productBadge.removeEventListener("mouseleave", hidePopup);
        productBadge.addEventListener("click", showPopup);
        producBadgePopClose.addEventListener("click", hidePopup);
        productBadgeContainer.removeEventListener("focus", showPopup);
        productBadgeContainer.removeEventListener("blur", hidePopup);
        productBadgeContainer.addEventListener('keydown', (keyEvent) => {
            if (keyEvent.keyCode === 13 || keyEvent.keyCode === 32) {
                showPopup()
            }
        });
        producBadgePopClose.addEventListener('keydown', (keyEvent) => {
            if (keyEvent.keyCode === 13 || keyEvent.keyCode === 32) {
                hidePopup()
            }
        });
    }
    else if(productBadge) {
        console.log("large")
        productBadge.addEventListener("mouseover", showPopup);
        productBadge.addEventListener("mouseleave", hidePopup);
        productBadge.removeEventListener("click", showPopup);
        producBadgePopClose.removeEventListener("click", hidePopup);
        productBadgeContainer.addEventListener("focus", showPopup);
        productBadgeContainer.addEventListener("blur", hidePopup);
    }
});
});

//Ingredient View All Open Correct Tab
document.addEventListener("DOMContentLoaded", (event) => {
    if(document.querySelector("[href='#product-content']")) {
        document.querySelector("[href='#product-content']").addEventListener('click', function(event) {
            document.querySelector(".tabs-nav__item-list #ingredients").click();
        });
    }
});

//Make Quiz Kit Decline Button Accessible
function waitForElm(selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }
        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                observer.disconnect();
                resolve(document.querySelector(selector));
            }
        });
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}
waitForElm('#quiz-kit-subscribe-VfHwmCN8Y-decline-button').then((quizSubBtn) => {
    quizSubBtn.addEventListener('keydown', event => {
        if (event.code === 'Space') {
            quizSubBtn.click();
            event.preventDefault();
        }
      })
});

// js/sections/before-after-image.js
var SplitCursor = class extends HTMLElement {
    connectedCallback() {
      this._parentSection = this.closest(".shopify-section");
      this._dragging = false;
      this._offsetX = this._currentX = 0;
      this._parentSection.addEventListener("pointerdown", this._onPointerDown.bind(this));
      this._parentSection.addEventListener("pointermove", this._onPointerMove.bind(this));
      this._parentSection.addEventListener("pointerup", this._onPointerUp.bind(this));
      window.addEventListener("resize", this._recalculateOffset.bind(this));
    }
    get minOffset() {
      return -this.offsetLeft - (document.dir === "rtl" ? this.clientWidth : 0);
    }
    get maxOffset() {
      return this.offsetParent.clientWidth + this.minOffset;
    }
    _onPointerDown(event) {
      if (event.target === this || this.contains(event.target)) {
        this._initialX = event.clientX - this._offsetX;
        this._dragging = true;
      }
    }
    _onPointerMove(event) {
      if (!this._dragging) {
        return;
      }
      this._currentX = Math.min(Math.max(event.clientX - this._initialX, this.minOffset), this.maxOffset);
      this._offsetX = this._currentX;
      this._parentSection.style.setProperty("--clip-path-offset", `${this._currentX.toFixed(1)}px`);
    }
    _onPointerUp() {
      this._dragging = false;
    }
    _recalculateOffset() {
      this._parentSection.style.setProperty("--clip-path-offset", `${Math.min(Math.max(this.minOffset, this._currentX.toFixed(1)), this.maxOffset)}px`);
    }
  };
  if (!window.customElements.get("split-cursor")) {
    window.customElements.define("split-cursor", SplitCursor);
  }

  document.querySelectorAll('.yotpo__reviews').forEach(function(element) {
    element.addEventListener('click', function(event) {
        event.preventDefault();
        document.querySelector(".tabs-nav__item-list .reviews__tab").click();
        
        const reviewWrapper = document.getElementById('reviews__wrapper');
        if (reviewWrapper) {
            setTimeout(function() {
                const topOffset = reviewWrapper.getBoundingClientRect().top + window.pageYOffset - 140;
                window.scrollTo({
                    top: topOffset,
                    behavior: 'smooth'
                });
            }, 300);
        } else {
            console.log('Element with id "reviews__wrapper" not found');
        }
    });
});

